import { ENV } from "base/constants";

import {
  DEV_ICON_VERSION,
  PRD_ICON_VERSION,
  UAT_ICON_VERSION
} from "./icons/version.js";

let iconsCache = {};
let illustrationCache = {};

let baseURL = null;

function getBaseURL() {
  let cdnPath = window.publicPathAlias || window.publicPath;
  if (!baseURL) {
    if (window.accountDetails.AppConfig.BaseEnv === ENV.PRD) {
      baseURL = `${window.location.protocol}${cdnPath}media/icons/kf/${PRD_ICON_VERSION}`;
    } else if (window.accountDetails.AppConfig.Env === ENV.UAT) {
      baseURL = `${window.location.protocol}${cdnPath}media/icons/kf/${UAT_ICON_VERSION}`;
    } else {
      baseURL = `https://pegasicdn2.zingworks.com/media/icons/kf/${DEV_ICON_VERSION}`;
    }
  }
  return baseURL;
}

export const IconService = {
  getIcon: (icon, size, stroke) => {
    return new Promise((resolve, reject) => {
      let url = `${getBaseURL()}/kf-icons/${icon}/${
        stroke ? size + "-" + stroke : "size-" + size
      }.svg`;
      if (iconsCache[url]) {
        resolve(iconsCache[url]);
      } else {
        fetch(url, { priority: "low" })
          .then((response) => response.text())
          .then((_icon) => {
            if (_icon.trim().startsWith("<svg")) {
              iconsCache[url] = _icon;
              resolve(_icon);
            } else {
              iconsCache[url] = "";
              resolve("");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  },
  getIllustration: (icon) => {
    return new Promise((resolve, reject) => {
      let url = `${getBaseURL()}/kf-illustrations/${icon}/${icon}.svg`;
      if (illustrationCache[url]) {
        resolve(illustrationCache[url]);
      } else {
        fetch(url, { priority: "low" })
          .then((response) => response.text())
          .then((_icon) => {
            if (_icon.trim().startsWith("<svg")) {
              illustrationCache[url] = _icon;
              resolve(_icon);
            } else {
              illustrationCache[url] = "";
              resolve("");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }
};
